import Vue from 'vue'
import moment from 'moment'
import ja from 'vee-validate/dist/locale/ja.json'
import { ValidationProvider, ValidationObserver, localize, extend } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

Object.keys(rules).forEach((key) => {
  const value: any = rules
  extend(key, value[key])
})

localize('ja', ja)

extend('phone', {
  validate(value) {
    const regs = [
      /^0\d-\d{4}-\d{4}$/,
      /^0\d{2}-\d{3}-\d{4}$/,
      /^0\d{3}-\d{2}-\d{4}$/,
      /^0\d{4}-\d-\d{4}$/,
      /^050-\d{4}-\d{4}$/,
      /^0120-\d{3}-\d{3}$/,
      /^(070|080|090)-\d{4}-\d{4}$/,
      /^(0570)-\d{3}-\d{3}$/
    ]
    return !!regs.find((reg) => reg.test(value))
  },
  message: '{_field_}は正しい形式ではありません'
})

extend('mobile', {
  validate(value) {
    return /^(070|080|090)-\d{4}-\d{4}$/.test(value)
  },
  message: '{_field_}は正しい形式ではありません'
})

extend('zip', {
  validate(value) {
    return /^[0-9]{3}-[0-9]{4}$/.test(value)
  },
  message: '{_field_}は正しい形式ではありません'
})

extend('total_size', {
  params: ['limit'],
  validate(value: File[], args: any) {
    const total = value.reduce((sum, file) => sum + file.size, 0)
    console.log('total', total)
    return total <= args.limit * 1000 * 1000
  },
  message: '合計ファイルサイズは {limit} MB以下である必要があります'
})

extend('rules', {
  params: ['rules'],
  validate(value: { started: string | null; ended: string | null }, args: any) {
    if (args.rules) {
      moment.locale('ja')
      const started = moment(value.started)
      const ended = moment(value.ended)
      const rule = args.rules.find((rule: any) => rule.day === started.format('ddd'))

      if (rule?.value === 2) {
        args.message = 'この日時は予約できません。別の日時を選んでください。'
        return false
      }

      if (rule?.value === 3) {
        const time = rule.times.find((time: any) => {
          const timeStarted = moment(started.format('YYYY-MM-DD ') + time.started)
          const timeEnded = moment(ended.format('YYYY-MM-DD ') + time.ended)
          return started.isBetween(timeStarted, timeEnded, null, '[]') && ended.isBetween(timeStarted, timeEnded, null, '[]')
        })
        if (!time) {
          args.message = 'この時間は予約できません。別の時間を選んでください。'
          return false
        }
      }
    }

    return true
  },
  message: (_field, params) => {
    return params.message || 'この日時は予約できません。別の日時を選んでください。'
  }
})

// 医師のアポイントの情報を取得して、時間の重複をチェックする
extend('overlap', {
  params: ['appointment'],
  validate(value: { started: string | null; ended: string | null }, args: any) {
    moment.locale('ja')
    const started = moment(value.started)
    const ended = moment(value.ended)
    const date = started.format('YYYY-MM-DD')

    if ((args.appointment[date]?.length || 0) > 0) {
      const time = args.appointment[date].find((appointment: any) => {
        const timeStarted = moment(appointment.startedAt)
        const timeEnded = moment(appointment.endedAt)
        return (
          started.isBetween(timeStarted, timeEnded.clone().subtract(1, 'minute'), null, '[]') ||
          ended.isBetween(timeStarted.clone().add(1, 'minute'), timeEnded, null, '[]') ||
          (timeStarted.isBetween(started, ended, null, '[]') && timeEnded.isBetween(started, ended, null, '[]'))
        )
      })
      if (time) {
        args.message = 'この日時は予約できません。別の日時を選んでください。'
        return false
      }
    }
    return true
  },
  message: (_field, params) => {
    console.log('message', _field)
    return params.message || 'この日時は予約できません。別の日時を選んでください。'
  }
})
